import { createSlice } from "@reduxjs/toolkit";
import {
  getRules,
  getInfo,
  getInstruction,
} from "../asyncThunk/serviceActions";

const initialState = {
  status: null,
  rules: [],
  info: [],
  instructions: [],
};

const slice = createSlice({
  name: "serviceSlice",
  initialState,
  extraReducers: (build) => {
    // build.addCase(getHelpMessage.fulfilled, (state, action) => {
    //   state.messages = [
    //     { ...state.messages },
    //     {
    //       type: "help",
    //       message: action.payload.description,
    //     },
    //   ];
    // });
    build.addCase(getRules.fulfilled, (state, action) => {
      state.rules = action.payload;
    });
    build.addCase(getInfo.fulfilled, (state, action) => {
      state.info = action.payload;
    });
    build.addCase(getInstruction.fulfilled, (state, action) => {
      state.instructions = action.payload;
    });
  },
});

export const serviceSlice = slice.actions;
export default slice.reducer;
